import { render, staticRenderFns } from "./LlmGpuDevicesEditor.vue?vue&type=template&id=0b310afc&scoped=true"
import script from "./LlmGpuDevicesEditor.vue?vue&type=script&lang=js"
export * from "./LlmGpuDevicesEditor.vue?vue&type=script&lang=js"
import style0 from "./LlmGpuDevicesEditor.vue?vue&type=style&index=0&id=0b310afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b310afc",
  null
  
)

export default component.exports